/**
 * Created by fers on 27.04.16.
 */
import React from 'react';
import PropTypes from 'prop-types';
import {viewWithDataGetPrimaryData} from '../box-utils/PrimaryData';
import {ParentBox, relayWrap} from './../box-utils/ParentBox.react.js';
import {FormattedMessage, defineMessages, IntlShape} from 'react-intl';
import {Button} from 'react-bootstrap';

import Error from './system/Error.react.js';
import {sendError, displayError} from '../../app/errorDisplayer';
import BoxDecorator from './../box-utils/BoxDecorator.react';
import LoadingButton from '../../fw/LoadingButton.react';
import ChannelIcon from '../../channel-defs/ChannelIcon.react';
import InvokeChannelActionMutation from '../../channels/InvokeChannelActionMutation.react';
import {lastPanelController} from '../EmbededPanelController';
import {ZELENA_POSTA_REAUTHORIZE} from '../../../server/backend/actions/ZelenaPostaConstants';
import config from '../../../common/config';
import EventTracker from '../../app/EventTracker';
import mutationError from '../../channel-defs/mutationError';
import {safeJSONparse} from "../../../common/util/safeJSONparse";
import Deferred from '../../fw/deferred';

const messages = defineMessages({
    errorUnknown: {id: 'invokeChannelAction.errorUnknown', 'defaultMessage': 'Unknown error during action'},
    errorDescription: {id: 'invokeChannelAction.errorDescription', 'defaultMessage': 'Error during action: {errorMessage}'},
});



class ZelenaPosta extends ParentBox {

    static handlerName = "zelena-posta";

    static propTypes = {
        intl: PropTypes.object,
        isPreview: PropTypes.bool,
        relay: PropTypes.object,
        viewWithData: PropTypes.object.isRequired,
    };

    static contextTypes = {
        router: PropTypes.object,
    };

	constructor(props) {
        super(props);

		this.state = {
			needAuthorization: false,
			isSending: false
		};
	}

    getIcon() {
        return "zelena-posta";
    }

	getServiceName() {
		return "Zelená pošta";
	}

    onClick = () => {
        let deferred = new Deferred();
		let self = this;

        let {view} = this.props.viewWithData;
        let data = viewWithDataGetPrimaryData(this.props.viewWithData);

        this.setState({
			isSending: true
		});

        let onSuccess = ({invokeChannelAction}) => {
            try {
				let resp = invokeChannelAction.response;
				let response = resp ? safeJSONparse(invokeChannelAction.response) : {};

                if (invokeChannelAction.success) {
                    if (response.url) {
                        /* idoklad always asks in 'onbeforeunload' */
                        if (data[0]['channelDefId'] === config.CHANNEL_DEF_IDOKLAD) {
                            window.open(response.url, '_blank');
                        } else {
                            top.location = response.url;
                        }
                    }

					this.setState({
						isSending: false
					});
                }
				else if (response && response.action && ZELENA_POSTA_REAUTHORIZE === response.action) {
					self.setState({
						needAuthorization: response,
						isSending: false
					});
				}
				else {
					let message = invokeChannelAction.message
						? this.props.intl.formatMessage(messages.errorDescription, {errorMessage: invokeChannelAction.message})
						: this.props.intl.formatMessage(messages.errorUnknown);

					let self = this;
					displayError(message).then(() => {
						self.setState({
							isSending: false
						});
					}).catch((e) => {
                        sendError(e);
                    });
                }
            } catch (e) {
                sendError(e);
            }

            deferred.resolve();
        };
        let onFailure = (transaction) => {
            let error = mutationError(transaction, false);
			let self = this;
            displayError(error).then(() => {
                self.setState({
                    isSending: false
                });
            }).catch((e) => {
                /* ignore error */
            });

            deferred.reject(error);
        };

        let args = {
            callbackUrl: lastPanelController().getLastURL(),
            entityDef_id: this.props.viewWithData.entityDef['realId'],
            key: data[0]['key'],
        };

        let actionName = "zelena-posta-send";

        EventTracker.trackEvent(EventTracker.EVENT_CLICKS, {
            event: 'zelena-posta-send',
            type: 'application'
        });

        let mutationArgs = {
            channel: this.props.viewWithData.screen.channel,
            connectedChannel: view.connectedChannel,
            channelDefId: data[0]['channelDefId'],
            channelEntityDefId: data[0]['channelEntityDefId'],
            entityDef: this.props.viewWithData.entityDef,
            actionName: actionName,
            args: args,
        };

        if (this.props.relay) {
            this.props.relay.commitUpdate(
                new InvokeChannelActionMutation(mutationArgs), {onSuccess: onSuccess, onFailure: onFailure}
            );
        }

        return deferred.promise;
    };

	grandAccess() {
		let self = this;

		let eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
		let eventer = window[eventMethod];
		let messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";
		// Listen to message from child window
		eventer(messageEvent, (event) => {
			if (window.config['app-url'] === event.origin) {
				if (event.data.eventName === 'dativery-grand-access-saved') {
					self.setState({
						needAuthorization: false
					});
					self.onClick();
				}
				else if (event.data.eventName === 'dativery-grand-access-error') {
					displayError(event.data.type);
				}
			}
		}, false);

		let screenHeight = window.screen.height;
		let height = 600;
		let top = (screenHeight - height) / 2;
		if (top < 0) {
			height = screenHeight;
			top = 0;
		}

		let screenWidth = window.screen.width;
		let width = 800;
		let left = (screenWidth - width) / 2;
		if (left < 0) {
			width = screenWidth;
			left = 0;
		}

		let grandAcccessWindow = window.open(this.state.needAuthorization.url, "grandAcccessWindow", "width=" + width + ",height=" + height + ",menubar=0,status=0,left=" + left + ",top=" + top + "");
		grandAcccessWindow.focus();
	}

    render() {
		if (this.state.needAuthorization) {
			return (
                <BoxDecorator icon={this.getIcon()} isPreview={this.props.isPreview} title={this.getServiceName()}>
                    <div style={{padding: '5px'}}>
						<p style={{paddingTop: '8px'}}><FormattedMessage defaultMessage="{serviceName} needs reauthorization." id="ZelenaPosta.reauthorization" values={{serviceName: this.getServiceName()}} /></p>
						<Button className="btn-primary" onClick={this.grandAccess.bind(this)}><i aria-hidden="true" className="fa fa-fw fa-check-circle-o"></i> <FormattedMessage defaultMessage="Grant access" id="channel.grantAccess" /></Button>
                    </div>
                </BoxDecorator>
            );
		}

        try {
            return (
                <BoxDecorator icon={this.getIcon()} isPreview={this.props.isPreview} title={this.getServiceName()}>
                    <div style={{padding: '5px'}}>
                        <LoadingButton className="btn btn-default" isLoading={this.state.isSending} onClick={this.onClick.bind(this)}>
							{this.state.isSending
								? (<FormattedMessage defaultMessage="Sending…" id="ZelenaPosta.sending" />)
								: (<span><ChannelIcon channelDef={{icon: this.getIcon(), name: this.getServiceName()}} size={24} />  <FormattedMessage defaultMessage="Send" id="ZelenaPosta.send" /></span>)
							}
						</LoadingButton>
                    </div>
                </BoxDecorator>
            );
        } catch (e) {
            sendError(e);
            return (<Error error={e} />);
        }
    }
}

export default relayWrap(ZelenaPosta);
